import { httpClient } from './http-client';
import { User } from '../types/api';

export class ProfileService {
  private static readonly ENDPOINTS = {
    PROFILE: '/profile',
  } as const;

  /**
   * Get the current user's profile
   */
  static async getProfile(): Promise<User> {
    const raw = await httpClient.get<any>(ProfileService.ENDPOINTS.PROFILE);
    return (raw as any).data || raw;
  }

  /**
   * Update the current user's profile
   */
  static async updateProfile(data: { display_name?: string }): Promise<User> {
    const raw = await httpClient.put<any>(ProfileService.ENDPOINTS.PROFILE, data);
    return (raw as any).data || raw;
  }
}
